import { useQuery } from '@tanstack/react-query';
import { Commitment } from '@solana/web3.js';
import { slotQueryKeys } from 'src/hooks/query/slot/slotQueryKeys';

export interface SlotState {
	currentSlot: number;
	commitment: Commitment | undefined;
	isSubscribed: boolean;
}

export function useSlotQuery() {
	return useQuery<SlotState | null>({
		queryKey: slotQueryKeys.slot(),
		queryFn: () => null,
		enabled: false,
		staleTime: Infinity,
		gcTime: 5 * 60 * 1000,
	});
}
